import "./App.css";
import image2 from "./assets/settings.png";
import image1 from "./assets/main.png";
import image3 from "./assets/multipage.png";
import image4 from "./assets/history.png";
import image5 from "./assets/downloadpanel.png";
import image6 from "./assets/picturemenu.png"; 
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import Slider from "./components/Slider";

function App() {
  const navbarLinks = [
    { url: "#", title: "Home" },
    { url: "https://techfirex.gumroad.com/l/wzjeL?_gl=1*lo39mb*_ga*NDA2MTE4NDU0LjE2NDIxMTU4MDk.*_ga_6LJN6D94N6*MTY0Mzg5MjM1OC4xMC4xLjE2NDM4OTIzNjMuMA..", title: "Buy Now" }
  ];


  return (
    <div className="App">
      <Navbar navbarLinks={navbarLinks} />
     
     <Hero/>
      <Slider
        imageSrc={image1}
        title={"Main"}
        subtitle={
          "Blazing - Fast Multithreaded Browser Based On WebView2 (fixed latest runtime x64)"
        }
      
      />     
      <Slider
        imageSrc={image2}
        title={"Settings"}
        subtitle={"High Performance, Super Costumizable"}
        flipped={true}       
      />
       <Slider
        imageSrc={image3}
        title={"Tabs"}
        subtitle={"High Performance, And Draggable"}    
      />
        <Slider
        imageSrc={image4}
        title={"History"}
        subtitle={"The History Panel"}
        flipped={true}
      />
       <Slider
        imageSrc={image5}
        title={"Download"}
        subtitle={"The Download Panel"}    
      />
        <Slider
        imageSrc={image6}
        title={"Floating"}
        subtitle={"The Floating Menu"}
        flipped={true}
      />
    </div>
  );
}

export default App;
